import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import { GET_REVIEW_APPROVAL, GET_REVIEW_DETAILS, GET_REVIEW_EXPORT, GET_REVIEW_LISTING } from "./actionTypes.js";

import { getReviewApprovalFail, getReviewApprovalSuccess, getReviewDetailsFail, getReviewDetailsSuccess, getReviewExportFail, getReviewExportSuccess, getReviewListingFail, getReviewListingSuccess } from "./actions.js"
import { reviewApprovalApi, reviewDetailsApi, reviewExportApi, reviewListingApi } from "./reviewApi.js";

function* fetchReviewListing({ payload: payload }) {
    try {
        const response = yield call(reviewListingApi, payload)
        yield put(getReviewListingSuccess(response))
    } catch (error) {
        yield put(getReviewListingFail(error))
    }
}

function* fetchReviewDetails({ payload: payload }) {
    try {
        const response = yield call(reviewDetailsApi, payload)
        yield put(getReviewDetailsSuccess(response))
    } catch (error) {
        yield put(getReviewDetailsFail(error))
    }
}

function* fetchReviewApproval({ payload: payload }) {
    try {
        const response = yield call(reviewApprovalApi, payload)
        yield put(getReviewApprovalSuccess(response))
    } catch (error) {
        yield put(getReviewApprovalFail(error))
    }
}

function* fetchReviewExport({ payload: payload }) {
    try {
        const response = yield call(reviewExportApi, payload)
        yield put(getReviewExportSuccess(response))
    } catch (error) {
        yield put(getReviewExportFail(error))
    }
}

function* ReviewSaga() {
    yield takeEvery(GET_REVIEW_LISTING, fetchReviewListing)
    yield takeEvery(GET_REVIEW_DETAILS, fetchReviewDetails)
    yield takeEvery(GET_REVIEW_APPROVAL, fetchReviewApproval)
    yield takeEvery(GET_REVIEW_EXPORT, fetchReviewExport)
}

export default ReviewSaga
